import { render, staticRenderFns } from "./Shampoo.vue?vue&type=template&id=32c97fc2&scoped=true&"
var script = {}
import style0 from "./Shampoo.vue?vue&type=style&index=0&id=32c97fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c97fc2",
  null
  
)

export default component.exports